import { Link } from "react-router-dom";
import { Container } from "reactstrap";
import { Btn, H2, H4, LI, UL } from "../../../AbstractElements";

const Unauthorized = () => {
  return (
    <div className="page-wrapper">
      <div className="error-wrapper maintenance-bg">
        <Container>
          <UL className="simple-list maintenance-icons">
            <LI>
              <i className="fa fa-cog" color="red"></i>
            </LI>
            <LI>
              <i className="fa fa-cog"></i>
            </LI>
            <LI>
              <i className="fa fa-cog"></i>
            </LI>
          </UL>
          <div className="unauthorized-heading">
            <H2 className="headline">UNAUTHORIZED ACCESS DETECTED</H2>
          </div>
          <H4 className="sub-content">
            {
              "Our system has detected that you are attempting to access a page or resource you are not authorized."
            }
            <br />
            {"We appreciate your understanding and cooperation."}
          </H4>
          <Link to={`${process.env.PUBLIC_URL}/dashboard`}>
            <Btn color="danger-gradien" size="lg" className="text-light">
              {"BACK TO DASHBOARD"}
            </Btn>
          </Link>
        </Container>
      </div>
    </div>
  );
};
export default Unauthorized;
